import "./base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Models ??= {};

AppointmentBooking.Wizard.Models.VisitTypeRuleSelection = class VisitTypeRuleSelection extends (
  AppointmentBooking.Wizard.Models.Base
) {};
